import ProjectNotesDetailsWrapper from "@/pages/contracten/notities/ProjectNoteDetailsWrapper"
import { checkPermissions } from "@/utils/checkPermissions"
import { createFileRoute, useParams } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/beheer/contracten/$contractId/notities/$noteThreadId/",
)({
  component: RouteComponent,
  beforeLoad: () => checkPermissions("read", "projects"),
})

function RouteComponent() {
  const { contractId, noteThreadId } = useParams({
    from: "/beheer/contracten/$contractId/notities/$noteThreadId/",
  })

  return (
    <ProjectNotesDetailsWrapper
      projectId={Number(contractId)}
      noteThreadId={Number(noteThreadId)}
    />
  )
}
